import {createSlice} from "@reduxjs/toolkit";

const initialDelayedTripsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  delayedtripForEdit: undefined,
  lastError: null,
  locations: null,
  locationsTotalCount: 0
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const delayedtripsSlice = createSlice({
  name: "delayedtrips",
  initialState: initialDelayedTripsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getDelayedTripById
    delayedtripFetched: (state, action) => {
      state.actionsLoading = false;
      state.delayedtripForEdit = action.payload.delayedtripForEdit;
      state.error = null;
    },
    // findDelayedTrips
    delayedtripsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    //findLocations
    locationsFetched: (state, action) => {
      const { locationsTotalCount, locations } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.locations = locations;
      state.locationsTotalCount = locationsTotalCount;
    },
    // createDelayedTrip
    delayedtripCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.delayedtripForEdit = action.payload.delayedtrip;
      state.entities.push(action.payload.delayedtrip);
    },
    // updateDelayedTrip
    delayedtripUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.delayedtrip.id) {
          return action.payload.delayedtrip;
        }
        return entity;
      });
    },
    // deleteDelayedTrip
    delayedtripDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteDelayedTrips
    delayedtripsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // delayedtripsUpdateState
    delayedtripsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
